<template>
    <div class="relative inline-block text-left">
        <div>
            <button
                href="#"
                aria-haspopup="true"
                aria-expanded="false"
                role="button"
                class="w-7 h-7 bg-white dark:bg-slate-800 justify-center items-center gap-2.5 flex focus:outline-slate-200"
                :class="{
                    'rounded-full border border-slate-200 dark:border-slate-700 shadow':
                        shape === 'circle',
                    'rounded text-slate-800 dark:text-slate-100': shape !== 'circle',
                }"
                @click="toggleMenu"
            >
                <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>
        </div>
        <div
            v-if="isOpen"
            class="absolute end-2 top-7 p-2 bg-white dark:bg-slate-800 rounded-lg shadow dark:shadow-slate-900/50 justify-start items-start flex flex-col z-50"
        >
            <button
                class="w-full flex rounded justify-start items-center gap-2 px-2 py-1.5 focus:outline-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 active:hover:bg-slate-100 whitespace-nowrap"
                @click="toggleComplete()"
            >
                <Icon :icon="alert.complete ? 'reset' : 'checkmark'" />

                <p class="text-slate-800 dark:text-slate-100 text-sm font-normal leading-tight">
                    {{ completeStatusLabel }}
                </p>
            </button>

            <button
                class="w-full flex rounded justify-start items-center gap-2 px-2 py-1.5 focus:outline-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 active:hover:bg-slate-100 whitespace-nowrap"
                @click="editAlert()"
                v-if="alert.status !== 'complete'"
            >
                <div class="w-5 h-5 relative">
                    <i class="fa-regular fa-pen-to-square fa-sm"></i>
                </div>

                <p class="text-slate-800 dark:text-slate-100 text-sm font-normal leading-tight">
                    Edit
                </p>
            </button>
            <button
                class="w-full flex rounded justify-start items-center gap-2 px-2 py-1.5 focus:outline-slate-200 hover:bg-slate-100 active:hover:bg-slate-100 whitespace-nowrap text-red-500"
                @click="removeAlert()"
            >
                <div class="w-5 h-5 relative">
                    <i class="far fa-trash-alt mr-1"></i>
                </div>
                <p class="text-sm font-normal leading-tight">Remove</p>
            </button>
        </div>
    </div>
</template>

<script>
import { useAlertsStore } from '@/store/alerts';
import { ref, watch, computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

export default {
    emits: ['toggle-menu'],
    components: {
        Icon,
    },
    props: {
        alert: {
            type: Object,
            required: true,
        },
        isOpen: {
            type: Boolean,
            required: true,
        },
        shape: {
            type: String,
            required: false,
            default: 'circle',
        },
    },
    setup(props, { emit }) {
        const alertsStore = useAlertsStore();
        const deleteConfirm = ref(false);

        const editAlert = () => {
            alertsStore.selectAlert(props.alert);
            alertsStore.setAlertModalState('step2.edit.indie');
            alertsStore.setShowAlertModal(true);
        };

        const removeAlert = () => {
            alertsStore.selectAlert(props.alert);
            alertsStore.setAlertModalState('step2.delete.indie');
            alertsStore.setShowAlertModal(true);
        };

        const toggleMenu = () => {
            emit('toggle-menu');
        };

        const completeStatusLabel = computed(() => {
            return props.alert.complete ? 'Set active' : 'Mark complete';
        });

        const toggleComplete = () => {
            alertsStore.toggleComplete(props.alert);
        };

        watch(
            () => props.isOpen,
            (newVal) => {
                if (!newVal) {
                    deleteConfirm.value = false;
                }
            }
        );

        return {
            toggleComplete,
            completeStatusLabel,
            deleteConfirm,
            editAlert,
            removeAlert,
            toggleMenu,
        };
    },
};
</script>
